<script>
export default {
  props: {
    src: {
      type: String,
      default: undefined
    },

    removable: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      visibleDialog: false
    }
  },

  computed: {
    fileExt() {
      return this.src.split('.').pop()
    },

    fileName() {
      return this.src.split('/').pop()
    }
  },

  methods: {
    showDialog() {
      this.visibleDialog = true
    },

    download() {
      const link = document.createElement('a')
      link.href = this.src
      link.target = '_blank'
      link.download = this.fileName
      link.click()
    },

    remove() {
      this.$emit('remove')
    }
  },

  render() {
    const useOverlay = icon => (
      <div class={this.$style.overlay}>
        <i class={[icon, this.$style.overlayIcon]}></i>
      </div>
    )

    return (
      <div>
        <div class={this.$style.container}>
          {this.fileExt !== 'pdf' ? (
            <div class={this.$style.innerContainer} onClick={this.showDialog}>
              <img src={this.src} alt="Preview image" class={this.$style.img} />
              {useOverlay('el-icon-view')}
            </div>
          ) : (
            <div class={this.$style.innerContainer} onClick={this.download}>
              <div>
                <i class={['el-icon-document', this.$style.pdfIcon]}></i>
                <div style={{ marginTop: '0.25rem' }}>{this.fileName}</div>
              </div>
              {useOverlay('el-icon-download')}
            </div>
          )}
          {this.removable && (
            <el-button
              type="danger"
              size="mini"
              circle
              icon="el-icon-close"
              class={this.$style.removeButton}
              onClick={this.remove}
            ></el-button>
          )}
        </div>
        <el-dialog
          visible={this.visibleDialog}
          on={{
            'update:visible': value => {
              this.visibleDialog = value
            }
          }}
        >
          {this.fileExt !== 'pdf' && (
            <img
              src={this.src}
              alt="Preview image"
              style={{ display: 'block', maxWidth: '100%', margin: '0 auto' }}
            />
          )}
        </el-dialog>
      </div>
    )
  }
}
</script>

<style lang="scss" module>
.container {
  position: relative;
  height: 100%;
  cursor: pointer;
}

.innerContainer {
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: $--color-text-primary;
  word-break: break-all;
  overflow: hidden;
}

.img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.pdfIcon {
  font-size: 3rem;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(black, 0.5);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: all 0.25s ease-out;

  .container:hover & {
    opacity: 1;
  }
}

.overlayIcon {
  font-size: 3rem;
}

.removeButton {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}
</style>
